import { Link } from "react-router-dom";
import { BRAND } from "../lib/site";

const SRC = `${process.env.PUBLIC_URL}/logo-horizontal.png`;
const SRC_LIGHT = `${process.env.PUBLIC_URL}/logo-horizontal-light.png`;

export const Logo = ({ light = false, className = "", imgClassName = "h-9 md:h-11 w-auto" }) => (
  <Link
    to="/"
    className={`inline-flex items-center shrink-0 ${className}`}
    aria-label={`${BRAND.name} — home`}
    data-testid="logo-link"
  >
    <img
      src={light ? SRC_LIGHT : SRC}
      alt={BRAND.name}
      width="546"
      height="132"
      className={imgClassName}
      decoding="async"
    />
  </Link>
);
